import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { borderTight, shadowLight } from 'app/colors';
import Icon from 'components/Kizen/Icon';
import IconButton from 'components/Kizen/IconButton';
import { useTranslation } from 'react-i18next';

const PlusButton = styled(IconButton)`
  position: absolute;
  bottom: -15px;
  left: calc(50% - 15px); // centered

  && svg {
    width: auto;
    height: 16px;
  }
`;

const ColumnWrapper = styled.div`
  position: relative;
  background: var(--color-background-white);
  height: 100%;
  ${({ columnWidth = 270 }) => css`
    width: ${columnWidth}px;
  `};
  margin-right: 20px;

  &:last-child {
    margin-right: 0;
  }
  .ViewText.DateText input {
    min-width: 0 !important;
  }
  ${borderTight}
  ${shadowLight}
`;

const BaseColumn = ({ onClickPlus, children, ...props }) => {
  const { t } = useTranslation();
  return (
    <ColumnWrapper {...props}>
      {children}
      {onClickPlus && (
        <PlusButton
          sizing="overlay"
          onClick={onClickPlus}
          title={t('Quick Add')}
        >
          <Icon icon="plus" />
        </PlusButton>
      )}
    </ColumnWrapper>
  );
};

export default BaseColumn;
